import { render, staticRenderFns } from "./OsEmpilhadeira.vue?vue&type=template&id=2f34d644&"
import script from "./OsEmpilhadeira.vue?vue&type=script&lang=js&"
export * from "./OsEmpilhadeira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports